import urlcat from 'urlcat';

import { Routes } from 'src/constants/routes';

export enum EmployeeDetailsViewTabRoutes {
  INFO = '',
  MODULES = 'modules',
  INTERVIEWS = 'interviews',
  AVAILABILITY = 'availability',
  AI = 'ai',
  ACTIVITY = 'activity',
}

const getInterviewerDetailsPageUrl = (
  interviewerId: string,
  tab: EmployeeDetailsViewTabRoutes = EmployeeDetailsViewTabRoutes.INFO
) => {
  if (tab) {
    return urlcat('', Routes.InterviewerDetails, { interviewerId, tab });
  }
  return urlcat('', Routes.InterviewerDetails, { interviewerId });
};

export default getInterviewerDetailsPageUrl;
